var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4.5V8h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v6H2V2a2 2 0 0 1 2-2h5.5L14 4.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.902 12.75h-2.925v2.65h-1.321V9h4.612v1.007h-3.29v1.74h2.925v1.002ZM10.301 10.007H8.197V15.4H6.875v-5.393H4.798V9h5.503v1.007ZM2.316 13.009h-.999V15.4H0V9h2.288c.378 0 .72.042 1.026.127.306.083.569.204.788.365.215.161.38.362.496.602.12.24.179.52.179.836 0 .228-.03.435-.09.62a1.618 1.618 0 0 1-.637.87c-.15.108-.319.202-.506.281l1.467 2.642v.057H3.6l-1.284-2.391Zm-.999-1.002h.975c.203 0 .381-.027.535-.08a.95.95 0 0 0 .38-.237.786.786 0 0 0 .182-.294c.044-.115.066-.242.066-.383 0-.17-.028-.32-.085-.448a.766.766 0 0 0-.243-.325 1.042 1.042 0 0 0-.357-.176 1.727 1.727 0 0 0-.482-.062h-.97v2.005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtfFile);
export default __webpack_public_path__ + "static/media/rtf-file.a8edb391721095999a1bafcb0d1c0481.svg";
export { ForwardRef as ReactComponent };